import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgViewTab = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M5.625 5.625h36.751v9.188H5.625zm0 13.781h36.751v9.188H5.625zm0 13.782h36.751v9.188H5.625z" }) }) })
});
export default SvgViewTab;
